<div fxLayout>
  <main fxFlex style="padding: 0px; margin-bottom: 0">
    <picture>
      <source srcset="assets/images/demo/properties/properties.webp" type="image/webp" />
      <img src="assets/images/demo/properties/properties.svg" class="demo-ux-image" (load)="isImageLoaded = true" />
    </picture>

    <div class="demo-callout rules__intro-text" *ngIf="isImageLoaded">
      <ng-container *ngIf="userTrialConnectAccountCta$ | async as userTrialConnectAccountCta">
        <h2>A better way to manage listings across platforms!</h2>
        <p class="notification__description">
          Properties allow you to group the same listings hosted on different booking platforms. This ensures you can
          manage all listings under a single calendar and avoid double bookings.
        </p>
        <p class="notification__description">
          Connect your {{ userTrialConnectAccountCta?.platformUi | titlecase }} account to import your listings into
          your Hospitable.com account and take charge of your life today!
        </p>

        <div class="rules__intro-buttons" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
          <button mat-flat-button (click)="clickedPrimaryCta(userTrialConnectAccountCta.connectAccountUrl)">
            Connect with {{ userTrialConnectAccountCta?.platformUi | titlecase }}
          </button>

          <a
            mat-flat-button
            class="button__secondary"
            (click)="
              clickedSecondaryCta(
                'https://my.hospitable.com/support-documentation/article/4639759-getting-started-with-properties'
              )
            ">
            Learn more
          </a>
        </div>
      </ng-container>
    </div>
  </main>
</div>
